import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import { Chart, Interval, Tooltip, registerInteraction, Axis, Coord } from "bizcharts";
import { Box } from "@mui/system";
import DownloadButton from "../Common/DownloadButton";

const GradientColumnsChart = (props) => {

    const [data, setData] = useState([]);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setData(results.data);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);


    registerInteraction("element-cursor-pointer", {
        start: [
            {
                trigger: "interval:mouseenter",
                action: (ctx) => {
                    ctx.view.canvas.setCursor("pointer");
                },
            },
        ],
        end: [
            {
                trigger: "interval:mouseleave",
                action: (ctx) => {
                    ctx.view.canvas.setCursor("default");
                },
            },
        ],
    });

    const [canvas, setCanvas] = useState(undefined);

    return (
        <Box>
            <Box display='flex' justifyContent='space-between'>
                <p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '.5rem' }}>{props.title}</p>
                <DownloadButton canvas={canvas} fileName={props.title} csv={data} isRaw />
            </Box>

            <Chart
                onGetG2Instance={chartInstance => {
                    setCanvas(chartInstance.canvas);
                }}
                height={400}
                autoFit
                data={data}
                interactions={["active-region", "element-cursor-pointer", 'element-active']}
                padding='auto'
            >
                <Coord transpose={window.innerWidth <= 900} />
                <Interval position="Animal product*Number of different pesticides found" state={{
                    active: {
                        style: {
                            stroke: 'white'
                        }
                    }
                }} color="rgba(0, 161, 200)" />
                <Axis name="Number of different pesticides found" />
                <Axis name="Animal product" label={{
                    autoRotate: true,
                    style: {
                        fontFamily: 'Roboto Condensed, sans-serif'
                    }
                }} />
                <Tooltip shared itemTpl={'<li style="padding: 10px 0" data-index={index}>'
                    + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
                    + '{name}: {value}'
                    + '</li>'} />
            </Chart>
        </Box>
    );
}

export default GradientColumnsChart;